import React from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import { durationToPixels, refSetter } from '../../../utils/helpers';

export const LUNCHBREAK = 'LUNCHBREAK';

const lunchBreakSource = {
  canDrag() {
    // You can disallow drag based on props
    return true;
  },

  isDragging(props, monitor) {
    return monitor.getItem().assignGuid === props.assignGuid;
  },

  beginDrag({ postcode, getTravelTimesByPostcode }, monitor, component) {
    if (postcode !== null && postcode !== '') {
      getTravelTimesByPostcode(postcode);
    }
    return {
      schedulingDisabled: false,
      requiredTime: component.props.restDuration,
      assignGuid: component.props.assignGuid,
    };
  },

  endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      return;
    }
    const dropResult = monitor.getDropResult();
    if (dropResult && dropResult.postingId) {
      props
        .updateLunchBreak({ availabilityId: props.availabilityId, restNewStartDate: dropResult.startDate })
        .then(props.refreshScheduler());
    }
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDraggable: monitor.canDrag(),
    isDragging: monitor.isDragging(),
    isAnythingDragged: monitor.getItemType() !== null,
  };
}

class LunchBreak extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.styles = {
      restDuration: { width: durationToPixels(this.props.restDuration) },
    };
  }

  setRef = refSetter.bind(this);

  render() {
    const { connectDragSource, isDragging, assignGuid, isCollapsed } = this.props;
    let collpased = '';
    if (isCollapsed === true) {
      collpased = '-overlap';
    }
    const lunchCardClassName = `assignment-info-wrapper asw-event-card--lunch${collpased}`;
    const lunchBreakCard = (
      <div className={lunchCardClassName} draggable="true" style={this.styles.restDuration}>
        <div role="presentation" className="assignment-info assignment-master" style={this.styles.restDuration}>
          <div className="patient-details">
            <div className="details">
              <div className="assignment-patient-name" />
              <div className="assignment-activities" />
            </div>
            <div className="icon-container">
              <span className="icon-lunch icon-svg asw-icon" />
            </div>
          </div>
        </div>
      </div>
    );

    const lunchBreakContainer = (
      <div className={`content ${isDragging ? 'dragging' : ''} `} style={this.styles.restDuration}>
        {connectDragSource(lunchBreakCard, { dropEffect: 'move' })}
      </div>
    );

    return (
      <div id={`timelineAssignGuid${assignGuid}`} ref={this.setRef('preview')} className="assignment">
        {lunchBreakContainer}
      </div>
    );
  }
}

LunchBreak.propTypes = {
  restDuration: PropTypes.number.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  assignGuid: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
};

export default DragSource(LUNCHBREAK, lunchBreakSource, collect)(LunchBreak);
